module.exports = __webpack_public_path__ + "img/plugin_wizard_websetup.png";